import dayjs from "dayjs";
import { Typography } from "@mui/material";
import { EventRow } from "./EventRow";
import { useScrollIntoView } from "../../../hooks/useScrollIntoView";
import { useOrganisationStyles } from "./useOrganisationStyles";
import { sortByDateAscending } from "../../../utils/sort";

export const EventsCalendar = ({ events }) => {
    const currentMonth = dayjs().format("YYYY-MM");

    const groupEventsByMonthYear = () =>
        [...events].sort(sortByDateAscending).reduce((accumulatedEvents, event) => {
            const yearMonth = dayjs(event.date).format("YYYY-MM");
            const groupedEvents = accumulatedEvents[yearMonth] || [];
            accumulatedEvents[yearMonth] = [...groupedEvents, event];
            return accumulatedEvents;
        }, {});

    const grouped = Object.entries(groupEventsByMonthYear());

    const selectedMonth = () => {
        const selectedIndex = grouped.findIndex(events => events[0] >= currentMonth);
        if (selectedIndex === -1) {
            return grouped.findIndex((events) =>
                events[0] === grouped.reduce((selectedMonthYear, currentEvent) =>
                    currentEvent[0] && currentEvent[0] > selectedMonthYear && currentMonth > currentEvent[0]
                        ? currentEvent[0]
                        : selectedMonthYear
                , ""));
        }
        return selectedIndex;
    };

    const selected = selectedMonth();

    return (
        <>
            {grouped.map(([monthYear, events], idx) =>
                <EventsCalendarMonth selected={(selected === idx)} key={monthYear} monthYear={monthYear} events={events} />
            )}
        </>
    );
};

export const EventsCalendarMonth = ({ monthYear, events, selected }) => {
    const ref = useScrollIntoView(selected);
    const classes = useOrganisationStyles();

    return (
        <section ref={ref} key={monthYear} className={classes.section}>
            <div className={classes.title}>
                <Typography variant="h5" >{dayjs(monthYear).format("MMMM YYYY")}</Typography>
            </div>
            {events.map(event => <EventRow key={event.id} event={event} />)}
        </section>
    );
};
